import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUmpiresList, updateUmp } from '../actions/umpireActions';
import UmpiresList from '../components/UmpiresListV2';

const mapDispatchToProps = dispatch => {
  return {
    getUmpiresList: seasonId => {
      dispatch(getUmpiresList(seasonId));
    },
    updateUmp: (memberId, umpireLevel, plateUmpire, baseUmpire, isMentor, isActive, isYouth, seasonId) => {
      dispatch(updateUmp(memberId, umpireLevel, plateUmpire, baseUmpire, isMentor, isActive, isYouth, seasonId));
    }
  };
};

const mapStateToProps = state => ({
  umpires: state.umpires.umpires,
  umpiresSeason: state.lists.umpiresSeason,
  umpiresSeasonList: state.lists.umpiresSeasonList,
  fetchingUmpiresList: state.lists.fetchingUmpiresList,
  userSeason: state.user.userSeason
});

const UmpiresListContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(UmpiresList));
export default UmpiresListContainer;



// WEBPACK FOOTER //
// ./src/containers/UmpiresListContainer.js